<div class="page-list ">
    <div class="header " >
        <div style="{{'background-image: url('+config.getBaseUrl()+'lnd/file/get_image?name=stories.png)' }}" class="background">
<!--            <img  src="assets/images/stories.png">-->
        </div>
        <div class="centerWidth">
            <div class="desc ">
                <h2  i18n="@@Success Stories">Success Stories</h2>
                <p>
                    {{listSummery}}
                </p>
<!--                <button class="button darkblue" (click)="clickMoreList()">-->
<!--                    <span i18n="@@See more">See more</span>-->
<!--                    <i class="pi pi-angle-left"></i>-->
<!--                </button>-->

            </div>
        </div>

    </div>


    <div style="height:105px;">

        <app-bottom-slider [logoType]="1" [opacity]="false"></app-bottom-slider>
    </div>

    <div id="page-list" class="centerWidth col-12 block lg:flex  ">
        <div class="col-12 lg:col-9 flex flex-wrap">
            <p-dataView #dv [value]="pages" [rows]="defListCount" [paginator]="true"
                        [totalRecords]="totalPages"
                        [lazy]="true" (onLazyLoad)="loadPageData(dv)"
            >
                <ng-template let-pagess pTemplate="list">
                    <div *ngFor="let page of pagess" class="col-12 lg:col-6 xl:col-6">
                        <app-story-list-item bgColor="{{page.style != null ? page.style.bgColor: ''}}"
                                             text="{{page.summary}}"
                                             logoSrc="{{page.style != null ? page.style.logoImage: ''}}"
                                             imgSrc="{{page.style != null ?  page.style.bgImage :''}}"
                                             [uid]="page.uid"
                        ></app-story-list-item>
                    </div>
                    <!--                    &lt;!&ndash;            ............................................&ndash;&gt;-->
                    <!--                    <button class=" button col-12 ">-->
                    <!--                        <span i18n="@@See more">See more</span>-->
                    <!--                    </button>-->
                </ng-template>
            </p-dataView>

        </div>

        <div [hidden]=" Object.keys(attributFilterList).length<1" class="filter col-12  lg:col-3 ">
            <div i18n="@@Filter by" style="font-weight: bold;">Filter by</div>
            <p-accordion [multiple]="true">
                <p-accordionTab *ngFor="let attr of attributFilterList | keyvalue;let i = index"
                                [selected]="i==0? true : false"
                                [header]="attr.key">
                    <div *ngFor="let attrVal of attr.value">
                        <p-checkbox [binary]="true"
                                    (onChange)="filterByAttribute($event,attr.key.trim()+':'+attrVal.trim())"></p-checkbox>
                        <label>{{attrVal}}</label>
                    </div>
                </p-accordionTab>
            </p-accordion>

        </div>
    </div>
    <!--    <div class="col-12">-->
    <!--        <app-performance-section></app-performance-section>-->
    <!--    </div>-->


</div>